import React, { FC } from 'react';
import { TableCell, TableRow, TableSortLabel } from '@material-ui/core';
import { ColumnConfig, SortDirection } from './types';
import { ColumnsSelect } from '../../../components';
import { useCommonStyles } from '../../../styles';

interface Props {
  columns: ColumnConfig[];
  sortable?: boolean;
  onSort: (key: string) => void;
  getSortDirection: (key: string) => SortDirection | undefined;
  isColumnSorted: (key: string) => boolean;
  columnSelect?: boolean;
  translation: any;
  allColumnLabels: string[];
  selectedColumns: string[];
  onSelectColumns: (columns: string[]) => void;
  headerClassName?: string;
  groupByKey?: string;
}

export const DataTableHeader: FC<Props> = ({
  columns,
  sortable,
  onSort,
  getSortDirection,
  isColumnSorted,
  columnSelect,
  translation,
  allColumnLabels,
  selectedColumns,
  onSelectColumns,
  headerClassName,
  groupByKey,
}) => {
  const commonClasses = useCommonStyles();

  const renderLabel = (col: ColumnConfig) => (
    <>
      {col.subLabel ? col.label.replace(col.subLabel, '').trim() : col.label}
      {col.subLabel && (
        <>
          <br />
          <span>{col.subLabel}</span>
        </>
      )}
    </>
  );

  return (
    <TableRow className={`${commonClasses.tableHeader} ${headerClassName || ''}`}>
      {groupByKey && <TableCell style={{ width: 30, padding: '6px 16px' }} />}

      {columns.map((col) => {
        const isSortable = sortable !== false && col.sortable !== false;
        const active = isColumnSorted(col.key);
        const direction = getSortDirection(col.key);

        return (
          <TableCell key={col.key} align={col.align || 'left'}>
            {isSortable ? (
              <TableSortLabel
                active={active}
                direction={active ? direction : 'asc'}
                onClick={() => onSort(col.key)}
              >
                <div>{renderLabel(col)}</div>
              </TableSortLabel>
            ) : (
              renderLabel(col)
            )}
          </TableCell>
        );
      })}

      {columnSelect && (
        <TableCell align="center" className={commonClasses.btnCell}>
          <ColumnsSelect
            translation={translation}
            reportColumns={allColumnLabels}
            selectedColumns={selectedColumns}
            handleSelectColumns={onSelectColumns}
          />
        </TableCell>
      )}
    </TableRow>
  );
};
